import React from "react";
import jyothy from "../../Content/images/esteemed-customers/jyothy.jpg";
import Onida from "../../Content/images/esteemed-customers/Onida.png";
import perfetti from "../../Content/images/esteemed-customers/perfetti.png";
import hector from "../../Content/images/esteemed-customers/hector.png";
//import schrieder from "../../Content/images/esteemed-customers/schrieber.png";
import atl from "../../Content/images/esteemed-customers/atl.jfif";
import pernod from "../../Content/images/esteemed-customers/pernod.png";
import Ceat from "../../Content/images/esteemed-customers/CEAT.jpg";
import Kimbal from "../../Content/images/esteemed-customers/Kimbal1.png";
import Sundrop from "../../Content/images/esteemed-customers/Sundrop.png";
import styles from "./login.module.css";

const OurCustomers = () => {
  return (
    <div>
      <div style={{ color: "white", textAlign: "center", 
  "fontFamily": "Playfair Display, serif",

       }}>
        <h5>Our Esteemed Customers</h5>
      </div>

      <div>
        {/* First row */}
        <div
          className={`d-flex justify-content-center`}
          style={{ gap: "15px" }}
        >
          <div className={`${styles.imageContainer}`}>
            <img src={jyothy} alt="Jyothy" className={`${styles.imageStyle}`} />
          </div>
          <div className={`${styles.imageContainer}`}>
            <img
              src={atl}
              alt="Apollo Tyre"
              className={`${styles.imageStyle}`}
            />
          </div>
          <div className={`${styles.imageContainer}`}>
            <img
              src={pernod}
              alt="Pernod Richard"
              className={`${styles.imageStyle}`}
            />
          </div>
          <div className={`${styles.imageContainer}`}>
            <img
              src={Ceat}
              alt="CEAT"
              className={`${styles.imageStyle}`}
            />
          </div>
          <div className={`${styles.imageContainer}`}>
            <img
              src={perfetti}
              alt="Perfetti"
              className={`${styles.imageStyle}`}
            />
          </div>
        </div>
        {/* Second row */}
        <div
          className="d-flex justify-content-center"
          style={{ gap: "15px", paddingTop: "10px" }}
        >
          <div className={`${styles.imageContainer}`}>
            <img src={hector} alt="Hector" className={`${styles.imageStyle}`} />
          </div>
          <div className={`${styles.imageContainer}`}>
            <img
              src={Kimbal}
              alt="Kimbal"
              className={`${styles.imageStyle}`}
            />
          </div>
          <div className={`${styles.imageContainer}`}>
            <img src={Onida} alt="Onida" className={`${styles.imageStyle}`} />
          </div>
          <div className={`${styles.imageContainer}`}>
            <img
              src={Sundrop}
              alt="Sundrop"
              className={`${styles.imageStyle}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurCustomers;
